module.exports = __webpack_public_path__ + "static/media/devoluciones.2da01875.png";